<template>
  <Button
    v-if="showInfo()"
    :icon="'pi ' + props.params.icon"
    severity="surface"
    text
    class="rounded-full!"
    :class="getSize()"
    @click="params.callback(props.params.data)"
  ></Button>
</template>

<script setup lang="ts">
const props = defineProps(["params"]);

const getSize = (): string => {
  if (props.params.size && props.params.size.toUpperCase() === "SMALL") return "w-6! h-6! p-0! mb-1! text-xl";
  else return "w-7! h-7! p-2! mb-2! text-xl";
};

const showInfo = (): boolean => {
  if (props.params.checkInfo != null) return props.params.checkInfo(props.params.data);
  return true;
};
</script>
